import { apiV2Root } from "consts";
import { useState } from "react";

export function useLiftRestriction(onDone?: () => void) {
  const [liftingId, setLiftingId] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  const liftRestriction = async (id: number, liftReason: string) => {
    if (liftingId !== null) return;

    setLiftingId(id);
    setError(null);

    try {
      const response = await fetch(`${apiV2Root}restrictions/${id}/lift/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ liftReason }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data?.error || `Request failed: ${response.status}`);
      }

      onDone?.();
    } catch (e: any) {
      setError(e?.message || "Unknown error");
    } finally {
      setLiftingId(null);
    }
  };

  return { liftingId, error, liftRestriction };
}
